module.exports = __webpack_public_path__ + "static/media/room-9.24bfb781.jpeg";